import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url, Base_url_bbbs, Base_url_live, Base_url_api_live, Base_url_bbbslive } from "../config";
import { useNavigate } from "react-router-dom";

import ReactDOM from "react-dom";
import ReactPaginate from "react-paginate";
import bigInt from "big-integer";

let Reneditedu = () => {
  let [data, setData] = useState();

  let [one, setOne] = useState();
  let [two, setTwo] = useState();
  let [three, setThree] = useState();
  let [four, setFour] = useState();
  let [five, setFive] = useState();

  let [loading, setLoading] = useState(false);

  let navigate = useNavigate();
  let [value, inputvalue] = useState();
  const [text, setText] = useState("");

  const [edu, setEdu] = useState("");
  const [uli, setUli] = useState("");

  useEffect(() => {
    Start();

    allrentdata();

    homepageheaderdata()
  }, []);

  let Start = async () => {
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
    }
  };


  let homepageheaderdata = async () => {

    try {
      let apicall = await axios({
        method: "get",
        url: Base_url_bbbs + "/admin/gethomejson",
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);

          console.log(Jsson, "Jsson inputvalueinputvalueinputvalue");
          if (Jsson.status === true) {
            inputvalue(Jsson.data);
          } else {
            alert("Failed");
          }
        })
        .catch((ee) => { });
    } catch (err) { }

  }

  let User = async (day, charge) => {

    if (charge === undefined || charge === "" || charge === null) {
      alert("Enter value");
      return
    }
    setLoading(true);
    console.log(day, charge, "day , charge");
    try {
      let token = await localStorage.getItem("token");

      let pp = { token, day, charge };
      let data = await AesEncrypt(pp);

      let apicall = await axios({  
        method: "post",
        url: Base_url_api_live + "/admin/changerentdataedu",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);

          console.log(Jsson, "Jsson");
          if (Jsson.status === true) {
            setData(Jsson.data);
          } else {
            alert("Failed");
          }
        })
        .catch((ee) => { });
    } catch (err) { }
    setLoading(false);
  };


  let Users = async (day, charge) => {


    setLoading(true);
    console.log(day, charge, "day , charge");
    try {
      let token = await localStorage.getItem("token");

      let pp = { token, day, charge, homeedit: true };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url_bbbslive + "/admin/changerentdataedu",
        data: pp,
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);

          console.log(Jsson, "Jsson");
          if (Jsson.status === true) {
            alert("Success");
          } else {
            alert("Failed");
          }
        })
        .catch((ee) => { });
    } catch (err) { }
    setLoading(false);
  };

  let allrentdata = async () => {
    try {
      let apicall = await axios({
        method: "get",
        url: Base_url_api_live + "/admin/rentalldataedu",
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);

          console.log(Jsson, "Jsson");
          if (Jsson.status === true) {
            setData(Jsson.data);
          } else {
            alert("Failed");
          }
        })
        .catch((ee) => { });
    } catch (err) { }
  };


  let Usercheked = async (day, charge) => {

    console.log(day, charge, 'charge fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff')


    try {
      let token = await localStorage.getItem("token");

      let pp = { token, day, charge };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url_api_live + "/admin/changerentactiveedu",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);

          console.log(Jsson, "Jsson");
          if (Jsson.status === true) {
            allrentdata()
          } else {
            alert("Failed");
          }
        })
        .catch((ee) => { });
    } catch (err) { }

  };


  let changecount = async (day, charge) => {  
       if (charge === undefined || charge === "" || charge === null) {
        alert("Enter value");
        return;
      }

      // Check if it's a number and not a decimal
      if (isNaN(charge) || !Number.isInteger(Number(charge))) {
        alert("Only integer values are allowed");
        return;
      } 
    console.log(day, charge, "day , charge");
    try {
      let token = await localStorage.getItem("token");

      let pp = { token, day, charge };
      let data = await AesEncrypt(pp);

      let apicall = await axios({  
        method: "post",
        url: Base_url_api_live + "/admin/changerentdataeducount",
        data: pp,
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);

          console.log(Jsson, "Jsson");
          if (Jsson.status === true) {
            alert("Success");
            setData(Jsson.data);
          } else {
            alert("Failed");
          }
        })
        .catch((ee) => { });
    } catch (err) { }   
  }

  return (
    <div>
      <div className="row">
        <Header />
        <div className="col-10" style={{ overflowY: 'scroll', height: '100vh', scrollbarWidth: 'none' }} >
          <p style={{ fontWeight: "700", marginTop: 20 }}>Edu Fees .. </p> 

          <div className="d-flex">
            <p style={{ marginRight: 10, marginTop: 2, width: 120 }}>
              Sameday{" "}
              <span style={{ fontWeight: "800", color: "red" }}>
                {"   "} {data?.sameday_charge + "%" || ""}
              </span>
            </p>
            <div style={{ marginRight: 10 }} className="d-flex flex-row gap-2">
              <div className=" ">
                <input
                  onChange={(e) => {
                    setOne(e.target.value);
                  }}
                  type="number"
                  style={{ width: "100%", marginBottom: 10 }}
                  placeholder="Enter Amount"
                />
              </div>
            </div>

            {loading === true ? (
              <p>Loading...</p>
            ) : (
              <button
                onClick={() => {
                  User("sameday", one);
                }}
                type="button"
                style={{ height: 33 }}
                class="btn btn-primary"
              >
                Submit
              </button>
            )}

            <div
              class="form-check form-switch "
              style={{ marginLeft: 10, marginTop: 4 }}
            >
              <input
                class="form-check-input"
                type="checkbox"
                id="flexSwitchCheckDefault"

                checked={data?.sameday_show}
                onChange={(e) => {
                  Usercheked('sameday', e.target.checked)
                }}
              />
              <label class="form-check-label" for="flexSwitchCheckDefault">
                Active
              </label>
            </div>
          </div>

          <div className="d-flex" style={{ marginTop: 20 }}>
            <p style={{ marginRight: 10, marginTop: 2, width: 120 }}>
              T1{" "}
              <span style={{ fontWeight: "800", color: "red" }}>
                {"   "} {data?.t1_charge + "%"}
              </span>
            </p>

            <div className="d-flex flex-row gap-2">
              <div className=" ">
                <input
                  onChange={(e) => {
                    setTwo(e.target.value);
                  }}
                  type="number"
                  style={{ width: "100%", marginBottom: 10 }}
                  placeholder="Enter Amount"
                />
              </div>

              {loading === true ? (
                <p>Loading...</p>
              ) : (
                <button
                  onClick={() => {
                    User("t1", two);
                  }}
                  type="button"
                  style={{ height: 33 }}
                  class="btn btn-primary"
                >
                  Submit
                </button>
              )}

              <div
                class="form-check form-switch "
                style={{ marginLeft: 10, marginTop: 4 }}
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="flexSwitchCheckDefault"
                  checked={data?.t1_show}
                  onChange={(e) => {
                    Usercheked('t1', e.target.checked)
                  }}
                />
                <label class="form-check-label" for="flexSwitchCheckDefault">
                  Active
                </label>
              </div>
            </div>
          </div>

          <div className="d-flex" style={{ marginTop: 20 }}>
            <p style={{ marginRight: 10, marginTop: 2, width: 120 }}>
              T2{" "}
              <span style={{ fontWeight: "800", color: "red" }}>
                {"   "} {data?.t2_charge + "%"}
              </span>
            </p>

            <div style={{ marginRight: 10 }} className="d-flex flex-row gap-2">
              <div className=" ">
                <input
                  onChange={(e) => {
                    setThree(e.target.value);
                  }}
                  type="number"
                  style={{ width: "100%", marginBottom: 10 }}
                  placeholder="Enter Amount"
                />
              </div>
            </div>

            {loading === true ? (
              <p>Loading...</p>
            ) : (
              <button
                onClick={() => {
                  User("t2", three);
                }}
                type="button"
                style={{ height: 33 }}
                class="btn btn-primary"
              >
                Submit
              </button>
            )}



            <div
              class="form-check form-switch "
              style={{ marginLeft: 10, marginTop: 4 }}
            >
              <input
                class="form-check-input"
                type="checkbox"
                id="flexSwitchCheckDefault"
                checked={data?.t2_show}
                onChange={(e) => {
                  Usercheked('t2', e.target.checked)
                }}
              />
              <label class="form-check-label" for="flexSwitchCheckDefault">
                Active
              </label>
            </div>
          </div>



          <div className="d-flex" style={{ marginTop: 20 }}>
            <p style={{ marginRight: 10, marginTop: 2, width: 120 }}>
              T3{" "}
              <span style={{ fontWeight: "800", color: "red" }}>
                {"   "} {data?.instant_charge + "%"}
              </span>
            </p>

            <div style={{ marginRight: 10 }} className="d-flex flex-row gap-2">
              <div className=" ">
                <input
                  onChange={(e) => {
                    setFour(e.target.value);
                  }}
                  type="number"
                  style={{ width: "100%", marginBottom: 10 }}
                  placeholder="Enter Amount"
                />
              </div>
            </div>

            {loading === true ? (
              <p>Loading...</p>
            ) : (
              <button
                onClick={() => {
                  User("t3", four);
                }}
                type="button"
                style={{ height: 33 }}
                class="btn btn-primary"
              >
                Submit
              </button>
            )}



            <div
              class="form-check form-switch "
              style={{ marginLeft: 10, marginTop: 4 }}
            >
              <input
                class="form-check-input"
                type="checkbox"
                id="flexSwitchCheckDefault"
                checked={data?.instant_show}
                onChange={(e) => {
                  Usercheked('t3', e.target.checked)
                }}
              />
              <label class="form-check-label" for="flexSwitchCheckDefault">
                Active
              </label>
            </div>
          </div>


          <div className="d-flex" style={{ marginTop: 20 }}>
            <p style={{ marginRight: 10, marginTop: 2, width: 120 }}>
              T4{" "}
              <span style={{ fontWeight: "800", color: "red" }}>
                {"   "} {data?.t4_charge + "%"}
              </span>
            </p>

            <div style={{ marginRight: 10 }} className="d-flex flex-row gap-2">
              <div className=" ">
                <input
                  onChange={(e) => {
                    setFive(e.target.value);
                  }}
                  type="number"
                  style={{ width: "100%", marginBottom: 10 }}
                  placeholder="Enter Amount"
                />
              </div>
            </div>

            {loading === true ? (
              <p>Loading...</p>
            ) : (
              <button
                onClick={() => {
                  User("t4", five );
                }}
                type="button"
                style={{ height: 33 }}
                class="btn btn-primary"
              >
                Submit
              </button>
            )}



            <div
              class="form-check form-switch "
              style={{ marginLeft: 10, marginTop: 4 }}
            >
              <input
                class="form-check-input"
                type="checkbox"
                id="flexSwitchCheckDefault"
                checked={data?.t4_show}
                onChange={(e) => {
                  Usercheked('t4', e.target.checked)
                }}
              />
              <label class="form-check-label" for="flexSwitchCheckDefault">
                Active
              </label>
            </div>
          </div>


          <div style={{ marginTop: 40 }} >
            <p>Edit home page presentage</p>



            <div className="d-flex">
              <p style={{ marginRight: 10, marginTop: 2, width: 120 }}>
                Education{" "}
                <span style={{ fontWeight: "800", color: "red" }}>

                </span>
              </p>
              <div style={{ marginRight: 10 }} className="d-flex flex-row gap-2">
                <div className=" ">
                  <input
                    onChange={(e) => {
                      setEdu(e.target.value);
                    }}
                    style={{ width: "100%", marginBottom: 10 }}
                    placeholder="Enter Amount"
                  />
                </div>
              </div>

              {loading === true ? (
                <p>Loading...</p>
              ) : (
                <button
                  onClick={() => {
                    Users("edu", edu);
                  }}
                  type="button"
                  style={{ height: 33 }}
                  class="btn btn-primary"
                >
                  Submit
                </button>
              )}

            </div>

            <div className="d-flex" style={{ marginTop: 20 }}>
              <p style={{ marginRight: 10, marginTop: 2, width: 120 }}>
                Utility{" "}
                <span style={{ fontWeight: "800", color: "red" }}>
                </span>
              </p>

              <div className="d-flex flex-row gap-2">
                <div className=" ">
                  <input
                    onChange={(e) => {
                      setUli(e.target.value);
                    }}
                    style={{ width: "100%", marginBottom: 10 }}
                    placeholder="Enter Amount"
                  />
                </div>

                {loading === true ? (
                  <p>Loading...</p>
                ) : (
                  <button
                    onClick={() => {
                      Users("uti", uli);
                    }}
                    type="button"
                    style={{ height: 33 }}
                    class="btn btn-primary"
                  >
                    Submit
                  </button>
                )}

              </div>
            </div>


          </div>


          <p style={{ fontWeight: "700", marginTop: 20 }}>Payment Count</p>


           <div className="d-flex">
            <p style={{ marginRight: 10, marginTop: 2, width: 120 }}>
              Sameday{" "}
              <span style={{ fontWeight: "800", color: "red" }}>
                {"   "} {data?.sameday_count  || ""}
              </span>
            </p>
            <div style={{ marginRight: 10 }} className="d-flex flex-row gap-2">
              <div className=" ">
                <input
                  onChange={(e) => {
                    setOne(e.target.value);
                  }}
                  type="number"
                  style={{ width: "100%", marginBottom: 10 }}
                  placeholder="Enter Amount"
                />
              </div>
            </div>

            {loading === true ? (
              <p>Loading...</p>
            ) : (
              <button
                onClick={() => {
                  changecount("sameday", one);
                }}
                type="button"
                style={{ height: 33 }}
                class="btn btn-primary"
              >
                Submit
              </button>
            )}
 
          </div>


            <div className="d-flex" style={{ marginTop: 20 }}>
            <p style={{ marginRight: 10, marginTop: 2, width: 120 }}>
              T1{" "}
              <span style={{ fontWeight: "800", color: "red" }}>
                {"   "} {data?.t1_count }
              </span>
            </p>

            <div className="d-flex flex-row gap-2">
              <div className=" ">
                <input
                  onChange={(e) => {
                    setTwo(e.target.value);
                  }}
                  type="number"
                  style={{ width: "100%", marginBottom: 10 }}
                  placeholder="Enter Amount"
                />
              </div>

              {loading === true ? (
                <p>Loading...</p>
              ) : (
                <button
                  onClick={() => {
                    changecount("t1", two);
                  }}
                  type="button"
                  style={{ height: 33 }}
                  class="btn btn-primary"
                >
                  Submit
                </button>
              )}
 
            </div>
          </div>

          <div className="d-flex" style={{ marginTop: 20 }}>
            <p style={{ marginRight: 10, marginTop: 2, width: 120 }}>
              T2{" "}
              <span style={{ fontWeight: "800", color: "red" }}>
                {"   "} {data?.t2_count  }
              </span>
            </p>

            <div style={{ marginRight: 10 }} className="d-flex flex-row gap-2">
              <div className=" ">
                <input
                  onChange={(e) => {
                    setThree(e.target.value);
                  }}
                  type="number"
                  style={{ width: "100%", marginBottom: 10 }}
                  placeholder="Enter Amount"
                />
              </div>
            </div>

            {loading === true ? (
              <p>Loading...</p>
            ) : (
              <button
                onClick={() => {
                  changecount("t2", three);
                }}
                type="button"
                style={{ height: 33 }}
                class="btn btn-primary"
              >
                Submit
              </button>
            )}


 
          </div>



          <div className="d-flex" style={{ marginTop: 20 }}>
            <p style={{ marginRight: 10, marginTop: 2, width: 120 }}>
              T3{" "}
              <span style={{ fontWeight: "800", color: "red" }}>
                {"   "} {data?.t3_count  }
              </span>
            </p>

            <div style={{ marginRight: 10 }} className="d-flex flex-row gap-2">
              <div className=" ">
                <input
                  onChange={(e) => {
                    setFour(e.target.value);
                  }}
                  type="number"
                  style={{ width: "100%", marginBottom: 10 }}
                  placeholder="Enter Amount"
                />
              </div>
            </div>

            {loading === true ? (
              <p>Loading...</p>
            ) : (
              <button
                onClick={() => {
                  changecount("t3", four);
                }}
                type="button"
                style={{ height: 33 }}
                class="btn btn-primary"
              >
                Submit
              </button>
            )}


 
          </div>


          <div className="d-flex" style={{ marginTop: 20 }}>
            <p style={{ marginRight: 10, marginTop: 2, width: 120 }}>
              T4{" "}
              <span style={{ fontWeight: "800", color: "red" }}>
                {"   "} {data?.t4_count  }
              </span>
            </p>

            <div style={{ marginRight: 10 }} className="d-flex flex-row gap-2">
              <div className=" ">
                <input
                  onChange={(e) => {
                    setFive(e.target.value);
                  }}
                  type="number"
                  style={{ width: "100%", marginBottom: 10 }}
                  placeholder="Enter Amount"
                />
              </div>
            </div>

            {loading === true ? (
              <p>Loading...</p>
            ) : (
              <button
                onClick={() => {
                  changecount("t4", five );
                }}
                type="button"
                style={{ height: 33 }}
                class="btn btn-primary"
              >
                Submit
              </button>
            )}
 
          </div>



          




        </div>
      </div>
    </div>
  );
};

export default Reneditedu;
